
<template>
  <div class="card shadow mb-4">
    <div class="card-header py-3">
      <a @click.prevent="back()" href="#" class="float-right"><i class="fas fa-fw fa-arrow-circle-left"></i> Back</a>
      <h6 class="m-0 font-weight-bold text-primary" v-if="partner">{{partner.name}} <i class="fas fa-fw fa-angle-double-right"></i> {{title}}</h6>
    </div>
    <div class="card-body">
      <div class="form-row">
        <div class="form-group col-md-12">
          <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
              <a class="nav-item nav-link active" id="nav-agents-tab" data-toggle="tab" href="#agents" role="tab" aria-controls="agents" aria-selected="true">System users</a>
            </div>
          </nav>
          <div class="tab-content" id="nav-tabContent">
            <div class="tab-pane fade show active p-3 border-left border-bottom border-right" id="agents" role="tabpanel" aria-labelledby="nav-agents-tab">
              <agents v-if="partner" :partner="partner"></agents>
            </div>
          </div>

        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-6">
          <error-reveal :error="error"></error-reveal>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global */

import { mapMutations } from 'vuex'
import merge from 'merge'
import * as mutationTypes from '../../store/mutation-types'
import ErrorReveal from '../../errors/Reveal'
import PartnerRequired from '../../mixins/PartnerRequired'
import partnerService from '../../services/partner'
import Agents from './settings/Agents'

export default {
  name: 'partners-settings',
  mixins: [PartnerRequired],
  components: {
    ErrorReveal,
    Agents
  },
  data () {
    return {
      partner: null,
      title: 'Settings',
      error: null
    }
  },
  methods: {
    ...mapMutations([mutationTypes.BUSY_ON, mutationTypes.BUSY_OFF]),
    onPartnerLoaded (error, partner) {
      this.error = error
      if (partner) {
        this.partner = partner
        if (this.$route.params.id) {
          this.load(this.$route.params.id)
        }
      } else {
        this.partner = null
      }
    },
    back () {
      this.$router.push({name: 'partner-list'})
    },
    reset () {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>
